export function initTestimonialsSlider(loco) {
  const section = document.querySelector(".testimonials");
  const el = section?.querySelector("[data-testimonials-slider]");
  const Swiper = window.Swiper;
  if (!section || !el || !Swiper) return null;

  const prevEl = section.querySelector("[data-testimonials-prev]");
  const nextEl = section.querySelector("[data-testimonials-next]");

  const slider = new Swiper(el, {
    slidesPerView: 1.15,
    spaceBetween: 20,
    grabCursor: true,
    watchOverflow: true,
    speed: 600,
    resistanceRatio: 0.65,
    navigation: {
      prevEl,
      nextEl,
    },
    breakpoints: {
      576: { slidesPerView: 1.5, spaceBetween: 24 },
      768: { slidesPerView: 2.2, spaceBetween: 28 },
      1200: { slidesPerView: 3.15, spaceBetween: 32 },
      1600: { slidesPerView: 3.5, spaceBetween: 36 },
    },
    on: {
      init() {
        loco?.bump?.();
      },
      slideChange() {
        loco?.bump?.();
      },
    },
  });

  return slider;
}
